<template>
  <div class="ic-report-monitor">
    <div class="ic-report-monitor__container">
      <h1 class="ic-report-monitor__title">{{ pageTitle }}</h1>
      <div class="ic-report-monitor__overview">
        <h2 class="ic-report-monitor__overview-title">{{ updatesTitle }}</h2>
        <p class="ic-report-monitor__overview-body">{{ overviewBody }}</p>
      </div>
      <div class="ic-report-monitor__list">
        <div
          class="ic-report-monitor__card"
          :class="{ 'ic-report-monitor__card--new': item.new }"
          v-for="item in data"
        >
          <div class="ic-report-monitor__content">
            {{ item.updates }}
            <span class="ic-report-monitor__name">{{ item.name }}</span>
            <span class="ic-report-monitor__date">{{ item.date }}</span>
          </div>
          <router-link
            :to="`/dashboard/report/people/${item.id}`"
            v-text="`View Updated Report`"
            class="ic-report-monitor__cta"
          />
        </div>
        <tz-paginate
          :base-url="baseUrl"
          :max-pages="maxPages"
          :items-per-page="itemsPerPage"
          :total-items="data.length"
          :current-page="currentPage"
          :has-trailing-slash="true"
          :use-router-links="true"
          :show-arrow-buttons="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Components
import TzPaginate from '@trazi/tz-paginate/src/tz-paginate.vue';
// Helpers
import Meta from '@/assets/js/shared/misc/meta.mjs';
const NBars = require('nbars/commonjs.js');
const pageCms = require(`@/assets/cms/pages/dashboard/dashboard-report-monitoring.json`);

export default {
  name: 'dashboard-report-monitor',
  layout: 'dashboard',
  components: { TzPaginate },
  data() {
    return {
      pageCms,
      pageTitle: pageCms.page_title,
      overviewBody: pageCms.overview.body,
      data: pageCms.mock_data,
      maxPages: pageCms.pagination.max_pages,
      itemsPerPage: pageCms.pagination.items_per_page,
      currentPage: this.$route.params.page ? +this.$route.params.page : 1,
      baseUrl: `/dashboard/monitor`
    };
  },
  computed: {
    updatesTitle() {
      const total = 2;
      const updatePluralText = total === 1 ? 'update' : 'updates';

      return NBars.transform(this.pageCms.overview.title, {
        total,
        updatePlural: updatePluralText
      });
    }
  },
  props: {
    cms: {
      type: Object,
      default: () => {
        return {
          global: require(`@/assets/cms/global.json`)
        };
      }
    }
  },
  head() {
    return {
      title: this.pageCms.meta_title,
      meta: this.pageCms.meta ? Meta.convertToNuxtMeta(this.pageCms.meta) : []
    };
  }
};
</script>
